import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharaditomumbaicab() {



const cardData = {
  keyword: " Kharadi to Mumbai Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Kharadi to Mumbai cab services, ensuring a hassle-free and smooth journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kharadi to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kharadi to Mumbai cab travel.",

topPlaces: [
 
  {
    title: "Aksa Beach",
    description: "Aksa Beach offers a quieter alternative to Mumbai's crowded beaches and is perfect for a relaxing coastal getaway. Travelers renting an Innova Crysta in Pune can comfortably reach this scenic destination and enjoy peaceful walks, stunning sunsets, and quality time with family or friends."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Visitors booking an Innova Crysta on rent in Pune can explore this heritage site while enjoying panoramic views of the Bandra-Worli Sea Link and Mumbai's beautiful coastline."
  },
  {
    title: "Phoenix Marketcity",
    description: "Phoenix Marketcity is one of Mumbai's largest shopping malls, offering premium brands, fine dining restaurants, entertainment zones, and multiplex cinemas. Choosing an Innova Crysta on rent in Pune makes the journey convenient for families and groups planning a day filled with shopping and entertainment."
  },
   {
    title: "Crawford Market",
    description: "Crawford Market is one of Mumbai's oldest and busiest shopping destinations, known for fresh produce, spices, dry fruits, handicrafts, and imported goods. Travelers booking an Innova Crysta on rent in Pune can comfortably reach this vibrant marketplace and enjoy shopping while experiencing the city's rich colonial heritage and bustling local culture."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is among Mumbai's most visited spiritual landmarks dedicated to Lord Ganesha. Renting an Innova Crysta in Pune offers a comfortable journey for families and devotees traveling to seek blessings. The temple's peaceful atmosphere and beautiful architecture make it a must-visit destination during a Mumbai trip."
  },
  {
    title: "Versova Beach",
    description: "Versova Beach is known for its peaceful shoreline, relaxing atmosphere, and beautiful Arabian Sea sunsets. Travelers choosing an Innova Crysta on rent in Pune can enjoy a scenic drive before spending quality time walking along the beach, tasting local seafood, and capturing memorable photographs."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    description: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya is one of India's finest museums, featuring thousands of historical artifacts, sculptures, paintings, and rare collections. Visitors hiring an Innova Crysta on rent in Pune can comfortably explore this cultural landmark while learning about India's fascinating artistic and historical heritage."
  },
  {
    title: "Nariman Point",
    description: "Nariman Point is a popular waterfront destination and one of Mumbai's most prestigious commercial areas. Booking an Innova Crysta on rent in Pune allows travelers to enjoy a relaxing road trip before admiring spectacular sea views, modern skyscrapers, and the beautiful promenade overlooking the Arabian Sea."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's iconic waterfront monument and a favorite attraction for tourists from across the country. Travelers hiring an Innova Crysta on rent in Pune can comfortably visit this historic landmark, enjoy ferry rides, admire colonial architecture, and experience the vibrant atmosphere along the Mumbai harbor."
  },
  {
    title: "Banganga Tank",
    description: "Banganga Tank is an ancient sacred water tank surrounded by historic temples and narrow heritage lanes. Renting an Innova Crysta in Pune allows visitors to comfortably explore this peaceful destination while discovering one of Mumbai's oldest religious and cultural landmarks, known for its timeless charm and spiritual significance."
  }
],



services: [
{
name: "Kharadi to Mumbai Cab",
description: "Kharadi to Mumbai cab service offers reliable intercity transportation from Kharadi in Pune to Mumbai city. Comfortable vehicles with professional drivers ensure safe travel through the Mumbai–Pune Expressway. Pickup services are available from homes, IT parks, hotels, and offices across Kharadi. Ideal for corporate travelers, tourists, and families."
},
{
name: "Kharadi to Mumbai Airport Cab",
description: "Kharadi to Mumbai Airport cab service provides dependable airport transportation from Kharadi to Chhatrapati Shivaji Maharaj International Airport. Vehicles offer spacious seating and luggage capacity for airport journeys. Professional drivers ensure punctual pickup and safe highway travel."
},
{
name: "Kharadi to Mumbai Taxi Service",
description: "Kharadi to Mumbai taxi service offers comfortable transportation for travelers heading from Pune to Mumbai. Vehicles are well maintained and suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Kharadi to Mumbai One Way Cab",
description: "Kharadi to Mumbai one way cab service provides convenient single-trip transportation between Pune and Mumbai. Sedan, Ertiga, and Innova vehicles are available depending on passenger requirements. Flexible booking options allow easy cab reservations."
},
{
name: "Kharadi to Mumbai International Airport Cab",
description: "Kharadi to Mumbai International Airport cab service offers reliable airport transfers for passengers traveling to the international terminal. Vehicles are comfortable and suitable for airport travel with luggage space. Professional drivers ensure safe and timely arrivals."
},
{
name: "Cab Service in Kharadi Pune",
description: "Cab service in Kharadi Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe rides across Kharadi and nearby Pune areas."
},
{
name: "Kharadi to Andheri Cab",
description: "Kharadi to Andheri cab service provides dependable transportation between Pune and Mumbai’s Andheri area. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kharadi to Dadar Cab Fare",
description: "Kharadi to Dadar cab fare services provide transparent pricing for passengers traveling between Kharadi and Dadar in Mumbai. Travelers can choose sedan, Ertiga, or Innova vehicles depending on comfort and budget."
},
{
name: "Kharadi to Mumbai Airport Drop",
description: "Kharadi to Mumbai Airport drop service offers convenient one-way transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers."
},
{
name: "Kharadi to Mumbai Darshan Cabs",
description: "Kharadi to Mumbai darshan cabs service offers sightseeing travel options for visitors planning to explore famous attractions in Mumbai. Comfortable vehicles and professional drivers ensure safe and enjoyable city tours."
},
{
name: "Kharadi to Mumbai Central Cabs",
description: "Kharadi to Mumbai Central cab service offers reliable transportation for travelers heading to Mumbai Central railway station. Vehicles are suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Chandan Nagar Mumbai Taxi",
description: "Chandan Nagar to Mumbai taxi service provides convenient transportation between Pune’s Chandan Nagar area and Mumbai city. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys."
},
{
name: "Pune Mumbai Velocity Cabs",
description: "Pune Mumbai Velocity Cabs service offers dependable transportation between Pune and Mumbai with comfortable vehicles and professional drivers ensuring safe expressway travel."
},
{
name: "Kharadi to Mumbai Cab Service",
description: "Kharadi to Mumbai cab service offers dependable transportation between Pune’s Kharadi area and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kharadi to Borivali Cab",
description: "Kharadi to Borivali cab service offers reliable transportation between Pune and Borivali in Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Cab Service in Kharadi",
description: "Cab service in Kharadi offers convenient transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe and smooth rides."
},
{
name: "Cab Service Kharadi Pune",
description: "Cab service Kharadi Pune provides reliable transportation for passengers traveling within Pune city and nearby destinations. Vehicles are suitable for daily commuting, airport transfers, and intercity travel."
},
{
name: "Cab in Central Kharadi Pune",
description: "Cab in Central Kharadi Pune offers quick taxi availability for passengers located in central Kharadi areas. Vehicles are comfortable and suitable for local and outstation travel."
},
{
name: "Innova Crysta on Rent in Kharadi",
description: "Innova Crysta on rent in Kharadi offers premium SUV rental for travelers seeking spacious and comfortable transportation. The vehicle is suitable for family trips, airport transfers, and corporate travel."
},
{
name: "Ertiga on Rent in Kharadi",
description: "Ertiga on rent in Kharadi provides comfortable SUV transportation suitable for families and small groups. The vehicle offers spacious seating and smooth highway travel performance."
},
{
name: "Sedan Cab on Rent in Pune",
description: "Sedan cab on rent in Pune offers economical transportation for passengers traveling within Pune or planning outstation trips. Sedan vehicles provide comfortable seating and fuel-efficient travel."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune and nearby destinations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
}
],

tableData: [
["Kharadi to Mumbai Cab","Kharadi to Mumbai Airport Cab"],
["Kharadi to Mumbai Taxi Service","Kharadi to Mumbai One Way Cab"],
["Kharadi to Mumbai International Airport Cab","Cab Service in Kharadi Pune"],
["Kharadi to Andheri Cab","Kharadi to Dadar Cab Fare"],
["Kharadi to Mumbai Airport Drop","Kharadi to Mumbai Darshan Cabs"],
["Kharadi to Mumbai Central Cabs","Chandan Nagar Mumbai Taxi"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Pune Mumbai Velocity Cabs","Kharadi to Mumbai Cab Service"],
["Kharadi to Borivali Cab","Cab Service in Kharadi"],
["Cab Service Kharadi Pune","Cab in Central Kharadi Pune"],
["Innova Crysta on Rent in Kharadi","Ertiga on Rent in Kharadi"],
["Sedan Cab on Rent in Pune","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Kharadi to Mumbai Airport Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kharadi to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kharadi to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming their ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Kharadi to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Kharadi to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kharadi",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, IT parks, hotels, and residential societies across Kharadi and nearby areas like Viman Nagar, Wagholi, Mundhwa, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kharadi to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kharadi to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Kharadi to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Kharadi to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kharadi to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Kharadi to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Kharadi and Mumbai." },
  { question: "Do you provide pickup from homes and offices in Kharadi?", answer: "Yes, our drivers provide doorstep pickup from homes, IT parks, offices, hotels, and residential societies across Kharadi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Kharadi to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pratik Deshmukh",
    feedback:
      "Travel arrangements from Kharadi to Mumbai were handled very efficiently. The cab was comfortable, arrived on time, and made the long journey quite smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aishwarya Kulkarni",
    feedback:
      "From Kharadi to Mumbai, the ride experience was really good. The vehicle was clean, the drive was steady, and the overall service felt reliable and stress-free.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharadi to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Kharadi to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Andheri, Mumbai Central, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Kharadi to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Kharadi to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kharadi to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Andheri, Mumbai Central & Mumbai airport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kharaditomumbaicab;